import styled from '@emotion/styled'

import {
  DataIcon,
  MessageIcon,
  NamingConventionsIcon,
  BuildIcon,
  ToolIcon,
  CompliantIcon,
} from '@segment/matcha/components/Icons/Brandbook'
import IconWrapper from '@segment/matcha/components/IconWrapper'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  header: `Engineered for performance`,
  description: `Our SDKs are built with your customers and data in mind. We take advantage of the latest technologies to save battery life, reduce bandwidth, and ensure data delivery.`,
}

const Performance = () => {
  return (
    <SectionBaseParentWrapper variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h3">{copy.header}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <FeatureBoxGroup />
      </Section.Contents>
    </SectionBaseParentWrapper>
  )
}

const features = [
  {
    title: `Message Batching`,
    text: `We batch API calls, which reduces the number of times we have to wake the radio.`,
    icon: <MessageIcon size="large" />,
  },
  {
    title: `Queuing`,
    text: `We queue events to disk, so you can record them even when a user is offline.`,
    icon: <NamingConventionsIcon size="large" />,
  },
  {
    title: `Open Source`,
    text: `Our libraries are open source, so you can take a look yourself and see how they work.`,
    icon: <BuildIcon size="large" />,
  },
  {
    title: `Gzip Compression`,
    text: `We use Gzip compression protocol to send less data over the wire and reduce bandwidth.`,
    icon: <ToolIcon size="large" />,
  },
  {
    title: `Security`,
    text: `Your data is encrypted from end to end using HTTPS and SSL security protocols.`,
    icon: <CompliantIcon size="large" />,
  },
  {
    title: `Server-to-Server Destinations`,
    text: `Our lightweight SDK allows you to use hundreds of mobile SDKs without having to add each one natively to your app.`,
    icon: <DataIcon size="large" />,
  },
]

const FeatureBoxGroup = () => (
  <Wrapper>
    <StyledColumnTrack columns={1} overrides={{ lg: 3 }}>
      {features.map((feature) => (
        <FeatureBoxBase key={feature.title} alignment="left" headerPosition="top">
          <FeatureBox.Header>
            <IconWrapper variant="transparent">{feature.icon}</IconWrapper>
          </FeatureBox.Header>
          <FeatureBox.Body>
            <FeatureBox.Title>{feature.title}</FeatureBox.Title>
            <FeatureBox.Text>{feature.text}</FeatureBox.Text>
          </FeatureBox.Body>
        </FeatureBoxBase>
      ))}
    </StyledColumnTrack>
  </Wrapper>
)

const SectionBaseParentWrapper = styled(SectionBase)`
  max-width: 1280px;

  ${Section.Wrapper} {
    padding-bottom: 0;
  }
`

const StyledColumnTrack = styled(ColumnTrack)`
  gap: 48px;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    column-gap: 32px;
    row-gap: 50px;
  }
`

const Wrapper = styled.div`
  max-width: 420px;

  ${({ theme }) => theme.breakpoints.up(`sm`)} {
    max-width: 100%;
  }
`

export default Performance
